import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getReportHistory, loadReportsParams, OrderHistoryResultModel } from "@tKgpco/Services/ReportsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<loadReportsParams, OrderHistoryResultModel>;

export const DispatchBeginLoadReportHistory: HandlerType = props => {
    props.dispatch({
        type: "Custom/ReportHistory/DispatchBeginLoadReportHistory",
        params: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getReportHistory(props.parameter);
};

export const DispatchCompleteLoadReportHistory: HandlerType = props => {
    props.dispatch({
        type: "Custom/ReportHistory/CompleteSmartSupplyCartsList",
        result: props.apiResult,
    });
};

export const chain = [DispatchBeginLoadReportHistory, RequestDataFromApi, DispatchCompleteLoadReportHistory];

export const loadReportHistory = createHandlerChainRunner(chain, "loadReportHistory");
export default loadReportHistory;
